"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionMetasToAccountsArray = exports.removeDuplicates = exports.flattenArrObject = exports.findAllIndexes = exports.deepCloneObject = void 0;
const clone_deep_1 = __importDefault(require("clone-deep"));
// TODO: there is probably a faster way to do this
const deepCloneObject = (obj) => {
    return (0, clone_deep_1.default)(obj);
};
exports.deepCloneObject = deepCloneObject;
const findAllIndexes = (arr, discriminator) => {
    var indexes = [];
    for (let i = 0; i < arr.length; i++) {
        if (discriminator(arr[i]))
            indexes.push(i);
    }
    return indexes;
};
exports.findAllIndexes = findAllIndexes;
const flattenArrObject = (arr) => arr.reduce((prev, item) => {
    return Object.assign(Object.assign({}, item), prev);
}, {});
exports.flattenArrObject = flattenArrObject;
const removeDuplicates = (items, toStringFn, fromStringFn) => {
    return [...new Set(items.map(toStringFn))].map(fromStringFn);
};
exports.removeDuplicates = removeDuplicates;
const actionMetasToAccountsArray = (actionMetas) => actionMetas.map((a) => {
    return {
        isSigner: a.isSigner,
        isWriteable: a.isWritable,
        address: a.pubkey,
    };
});
exports.actionMetasToAccountsArray = actionMetasToAccountsArray;
